import { useAuth } from '@supsupclub/ui-components';

import { BookingStateAtom } from './store';

export const MINIMUM_BOARDS_NR = 1;
export const MAXIMUM_BOARDS_NR = 16;
export const MINIMUM_DURATION = 1;
export const MAXIMUM_DURATION = 4;

export const useShouldCompleteProfile = () => {
  const { profile, isUSCAccount } = useAuth();
  if (!profile || isUSCAccount) {
    return false;
  }

  if (
    !profile.firstName ||
    !profile.lastName ||
    !profile.phoneNumber ||
    !profile.street ||
    !profile.country ||
    !profile.gender ||
    !profile.postcode ||
    !profile.city ||
    !profile.language ||
    !profile.dateOfBirth
  ) {
    return true;
  }
  return false;
};

export const isBookingSessionComplete = (booking: BookingStateAtom) => {
  if (
    booking?.locationId &&
    booking?.boardsNumber &&
    booking?.date &&
    booking?.time
  ) {
    return true;
  }

  return false;
};

export const TIMEZONE = 'Europe/Amsterdam';
